
import { db } from '../../../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Logs a device action to the database.
 * @param {string} deviceId - The ID of the device.
 * @param {string} actionType - 'create', 'update', 'transfer', 'service', 'delete'
 * @param {string} description - Brief description of the action.
 * @param {string} userId - ID of the user performing the action.
 * @param {object} metadata - Optional metadata (e.g., old/new values, transfer details).
 */
export const logDeviceAction = async (deviceId, actionType, description, userId, metadata = {}) => {
    try {
        await addDoc(collection(db, 'device_logs'), {
            deviceId,
            actionType,
            description,
            userId,
            timestamp: serverTimestamp(),
            metadata
        });
    } catch (error) {
        console.error("Error logging device action:", error);
        // We log the error but don't throw it to avoid breaking the main flow.
        // In a strict audit environment, this might need to be blocking.
    }
};
